import { useEffect, useState } from 'react';
import { Dialog, Pane, Text} from 'evergreen-ui';
import { fetchGuestAttachments } from '../services/guestsServices';

const GuestViewDialog = ({ isShown, onClose, guest }) => {
  const [attachments, setAttachments] = useState([]);

  useEffect(() => {
    if (!isShown || !guest || !guest.id) return;
    let cancelled = false;
    const load = async () => {
      try {
        const atts = await fetchGuestAttachments(guest.id);
        if (!cancelled) setAttachments(atts || []);
      } catch (err) {
        console.error('Errore fetch attachments in GuestViewDialog', err);
      }
    };
    load();
    return () => { cancelled = true; };
  }, [isShown, guest]);

  const title = guest ? `Dettagli ospite: ${guest.nome || ''} ${guest.cognome || ''}` : 'Dettagli ospite';

  return (
    <Dialog isShown={isShown} title={title} onCloseComplete={onClose} hasFooter={false} shouldAutoFocus={false}>
      <Pane display="flex" flexDirection="column" gap={8}>
        {!guest ? (
          <Text>Caricamento...</Text>
        ) : (
          <>
            <Pane>
              <Text><strong>Nome:</strong> {guest.nome}</Text>
            </Pane>
            <Pane>
              <Text><strong>Cognome:</strong> {guest.cognome}</Text>
            </Pane>
            <Pane>
              <Text><strong>Sesso:</strong> {guest.sesso}</Text>
            </Pane>
            <Pane>
              <Text><strong>Data di nascita:</strong> {guest.data_nascita ? guest.data_nascita.split('-').reverse().join('/') : ''}</Text>
            </Pane>
            <Pane>
              <Text><strong>Luogo di nascita:</strong> {guest.luogo_nascita}</Text>
            </Pane>
            <Pane>
              <Text><strong>Residenza:</strong> {guest.residenza}</Text>
            </Pane>
            <Pane>
              <Text><strong>Domicilio:</strong> {guest.domicilio}</Text>
            </Pane>
            <Pane>
              <Text><strong>Motivazione:</strong> {guest.motivazione}</Text>
            </Pane>
            <Pane>
              <Text><strong>PEI:</strong> {guest.revisione_pei_url ? <Text cursor="pointer" color="blue" onClick={() => window.open(guest.revisione_pei_url, '_blank')}>{guest.revisione_pei_url.split('/').pop()}</Text> : 'Nessun PEI'}</Text>
            </Pane>

            <Pane>
              <Text fontWeight={600}>Allegati</Text>
              <Pane marginTop={6} display="flex" flexDirection="column" gap={6}>
                {attachments && attachments.length > 0 ? (
                  attachments.map(att => (
                    <Text key={att.id} cursor="pointer" color="blue" onClick={() => window.open(att.file_url, '_blank')}>{att.file_name}</Text>
                  ))
                ) : (
                  <Text>Nessun allegato.</Text>
                )}
              </Pane>
            </Pane>
          </>
        )}
      </Pane>
    </Dialog>
  );
};

export default GuestViewDialog;
